/**
 * 日期筛选
 */
export default {
    label: "日期",
    value: 1,
    // value: 30,
    options: [
        {
            value: 1,
            label: "本月"
        },
        {
            value: 2,
            label: "上个月"
        },
        {
            value: 3,
            label: "近三月"
        },
        {
            value: 4,
            label: "近半年"
        },
        {
            value: 5,
            label: "本年度"
        },
        {
            value: 6,
            label: "上年度"
        },
        {
            value: -1,
            label: "自定义"
        },
        // {
        //     value: 0,
        //     label: "今天"
        // },
        // {
        //     value: 7,
        //     label: "近7天"
        // },
        // {
        //     value: 30,
        //     label: "近30天"
        // },
        // {
        //     value: -1,
        //     label: "自定义"
        // }
    ],
    beforeChange(filter, vm, next) {
        if (filter.value == -1) {
            // 选择日期范围
            vm.$weui.dateRangePicker(function (begin, end) {
                filter.begin = begin;
                filter.end = end;
                next();
            });
        } else {
            next();
        }
    },
    /**
     * 返回日期区间条件
     */
    fn(value, filter, vm) {
        var begin,
            end,
            now = new Date(),
            year = now.getFullYear(),
            month = now.getMonth(),
            day = now.getDate();
        switch(value) {
            case 1:
                begin = new Date(year, month, 1);
                end = new Date(year, month + 1, 0, 23, 59, 59);
                break;
            case 2:
                begin = new Date(year, month - 1, 1);
                end = new Date(year, month, 0, 23, 59, 59);
                break;
            case 3:
                begin = new Date(year, month - 2, 1);
                end = new Date(year, month, day, 23, 59, 59);
                break;
            case 4:
                begin = new Date(year, month - 5, 1);
                end = new Date(year, month, day, 23, 59, 59);
                break;
            case 5:
                begin = new Date(year, 0, 1);
                end = new Date(year + 1, 0, 0, 23, 59, 59);
                break;
            case 6:
                begin = new Date(year - 1, 0, 1);
                end = new Date(year, 0, 0, 23, 59, 59);
                break;
            case -1:
                begin = filter.begin;
                end = filter.end;
                break;
        }
        // if (value != -1) {
        //     begin = new Date(year, month, day - value);
        //     end = new Date(year, month, day, 23, 59, 59);
        // } else {
        //     begin = filter.begin;
        //     end = filter.end;
        // }
        var fmt = "yyyy-MM-dd hh:mm:ss",
            beginStr = vm.dateFormat(begin, fmt),
            endStr = vm.dateFormat(end, fmt);
        return {
            type: "date",
            field: filter.name,
            operation: "between",
            value: beginStr + "," + endStr
        };
    }
};